module.exports = __webpack_public_path__ + "img/bg-accident-item-2.9d5f05b8.png";